import React from "react";

import { Provider } from "react-redux";
import { store, persistor } from "./Redux/store.js";
import { PersistGate } from "redux-persist/integration/react";
import Portafolio from "./Views/Portafolio";

export const CravingApp = () => {
	return (
		<div>
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<Portafolio/>
				</PersistGate>
			</Provider>
		</div>
	);
};
